<template lang="pug">
v-row(align="center")
  v-col(cols="6"  v-if="!$vuetify.breakpoint.mobile" justify="center" align="center")
    v-sheet.transparent
      v-img(src="@/assets/login.png" max-width="360")
      v-sheet.transparent(width="380")
        h2.mt-12 Lorem, ipsum.
        p.mt-4 Lorem ipsum dolor sit, amet consectetur adipisicing elit. Facere ipsam expedi.
  v-col(cols="12" lg="6" :class="$vuetify.breakpoint.mobile?'px-0':''")
    v-sheet(min-height="70vh")
      v-sheet(
        elevation="4"
        rounded="lg"
        class="mx-auto"
        min-height="200"
        width="500"
        class="pa-10")
        h2.mb-10(:class="$vuetify.breakpoint.mobile?'text-center':''") Asan Login
        v-list.mb-4
          v-list-item.account-list
            v-list-item-avatar
              v-icon(class="grey lighten-1" dark) mdi-account
            v-list-item-title John Doe
        v-form(ref="form" v-model="valid" lazy-validation)
          v-text-field(
            prefix="+994"
            outlined
            v-model="phone"
            :rules="phoneRules"
            label="Phone"
            v-mask="'(##) ### ## ##'"
            required)
          v-btn.rounded-lg(id="asan_continue" depressed block x-large color="primary"
            @click="message = message ? '' : 'Password or email wrong'") {{ $t('action.continue') }}
</template>
<script>
export default {
  name: 'AsanLoginPage',
  data() {
    return {
      show1: false,
      message: '',
      phone: '',
    };
  },
};
</script>
<style lang="scss" scoped>
.account-list {
  background: #FAFAFA;
  border-radius: 10px;
}
</style>
